var document = require('./_global').document;
module.exports = document && document.documentElement;



//////////////////
// WEBPACK FOOTER
// /home/gitlab-runner/builds/VyQQATNu/0/groupe-dev/nm17/node_modules/core-js/modules/_html.js
// module id = Ed9o
// module chunks = 0